import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { SeoProps } from 'components/seo/types'
import { useTranslation } from 'next-i18next/pages'
import { cmsLib } from 'lib/index'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import { FAQCategories } from 'features/faq-page/types'
import AncienneBelgique from 'features/ancienne-belgique/AncienneBelgique'
import { AncienneBelgiqueProps } from 'features/ancienne-belgique/types'
import { AB_SIMULATION_SALES_OFFICE } from 'features/ancienne-belgique/constants'

const AncienneBelgiquePage = (props: AncienneBelgiqueProps) => {
  const { t } = useTranslation('ancienneBelgique')

  const SEO: SeoProps = {
    description: t('seo.description'),
    title: t('seo.title')
  }

  return (
    <Layout seo={SEO} simulationSalesOffice={AB_SIMULATION_SALES_OFFICE}>
      <AncienneBelgique {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const faqCategories = (await cmsLib.getFaqCategories(faqCategoriesSlugs[FAQCategories.ANCIENNE_BELGIQUE], locale)) || []

  return {
    props: {
      faqCategories,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'ancienneBelgique'], i18nConfig))
    }
  }
}

export default AncienneBelgiquePage
